import { useEffect, useState } from 'react';
import api from './api';

/*
 * Whether CRM is open to this person; the server decides (GET /crm/access). App and Sidebar share
 * one lookup. The last answer is remembered per person, so the CRM link is right from the first
 * paint; with no answer yet it stays hidden rather than appearing and then vanishing.
 */
const cacheKey = user => `crm-access-${user?._id || user?.id || ''}`;
const remembered = user => {
    try { const value = localStorage.getItem(cacheKey(user)); return value === null ? null : value === 'true'; } catch { return null; }
};

let lookup;
function checkAccess(token, user) {
    if (!lookup || lookup.token !== token) {
        lookup = {
            token,
            promise: api.get('/crm/access').then(response => {
                const enabled = Boolean(response.data.enabled);
                try { localStorage.setItem(cacheKey(user), String(enabled)); } catch { /* storage full or blocked */ }
                return enabled;
            }).catch(() => {
                // A failure is not remembered, so a blip does not hide CRM for the session.
                lookup = null;
                return false;
            }),
        };
    }
    return lookup.promise;
}
export function useCRMAccess(user) {
    const token = localStorage.getItem('token');
    const [state, setState] = useState(() => ({ enabled: Boolean(token) && remembered(user) === true, loaded: !token }));
    useEffect(() => {
        let active = true;
        if (!token) { setState({ enabled: false, loaded: true }); return undefined; }
        checkAccess(token, user).then(enabled => { if (active) setState({ enabled, loaded: true }); });
        return () => { active = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    return state;
}
